export const isValidHttpUrl = (value: string): boolean => {
  const trimmed = value.trim();

  if (/\s/.test(trimmed)) {
    return false;
  }

  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};
